module.exports = __webpack_public_path__ + "img/file.2848a504.svg";